module.exports = __webpack_public_path__ + "static/img-burger.8d1cf064.jpg";